import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/imprimirEtiquetaPDF`, method: 'POST', body: values, token: token})
}